import React from "react";
import { Collapse, Typography } from "antd";
import MainLayout from "../../components/layouts/MainLayout";

const { Panel } = Collapse;
const { Title, Text } = Typography;

const FAQ = () => {
  const faqData = [
    {
      title: "Quick Verification",
      items: [
        { label: "How to perform a Quick Verification", link: "/faq/quick-verification" },
        { label: "Verification Requirements", link: "/faq/verification-requirements" },
      ],
    },
    {
      title: "Templates",
      items: [
        { label: "How Templates Work", link: "/faq/templates/how-it-works" },
        { label: "Create a New Template", link: "/faq/templates/create" },
      ],
    },
    {
      title: "My Forms",
      items: [
        { label: "How to Create Forms", link: "/faq/forms/create" },
        { label: "Editing a Form", link: "/faq/forms/edit" },
      ],
    },
    {
      title: "Qinisure",
      items: [
        { label: "What is Qinisure?", link: "/faq/qinisure/intro" },
        { label: "How to Get Started", link: "/faq/qinisure/get-started" },
      ],
    },
    {
      title: "Wallet",
      items: [
        { label: "Funding Your Wallet", link: "/faq/wallet/fund" },
        { label: "Wallet Limits", link: "/faq/wallet/limits" },
      ],
    },
    {
      title: "Subscriptions",
      items: [
        { label: "Billing Cycles", link: "/faq/subscriptions/billing" },
        { label: "Upgrade Plan", link: "/faq/subscriptions/upgrade" },
      ],
    },
  ];

  return (
    <MainLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: 50,
        }}
      >
        <div
          style={{
            width: "80%",
            background: "#fff",
            padding: "40px 50px",
            borderRadius: "20px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          }}
        >
          {/* TITLE */}
          <Title level={3} style={{ textAlign: "center", marginBottom: 5 }}>
            Need Help? We've Got Answers
          </Title>

          <Text
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "16px",
              color: "#666",
              marginBottom: "40px",
            }}
          >
            Explore our most commonly asked questions and find the information you need.
          </Text>

          {/* COLLAPSE */}
          <Collapse
            accordion
            expandIconPosition="end"
            style={{
              background: "transparent",
            }}
            items={faqData.map((section, index) => ({
              key: index,
              label: (
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  {section.title}
                </span>
              ),
              children: (
                <div style={{ paddingLeft: 5, paddingTop: 10 }}>
                  {section.items.map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom: 14,
                      }}
                    >
                      <a
                        href={item.link}
                        style={{
                          fontSize: "15px",
                          color: "#1677ff",
                          textDecoration: "none",
                          transition: "0.2s",
                        }}
                        onMouseEnter={(e) => (e.target.style.opacity = "0.7")}
                        onMouseLeave={(e) => (e.target.style.opacity = "1")}
                      >
                        {item.label}
                      </a>
                    </div>
                  ))}
                </div>
              ),
              style: {
                background: "#fff",
                borderRadius: "12px",
                marginBottom: "12px",
                border: "1px solid #f0f0f0",
                padding: "5px 15px",
              },
            }))}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default FAQ;
